import { Card, Collapse } from 'react-bootstrap'
import style from '../Styles/index.module.scss'
import { IProduct, IProductGroup } from '../../../types/product'
import ProductCard from '../../ProductCard/ProductCard'
import { NoData } from '../../NoData'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import AppButton from '../../buttons/AppButton/AppButton'
import { ModalTypes } from '../../../types/modals'
import { showModal } from '../../../store/actions/modalActions'
import { User } from '../../../entity/User'
import { useExpand } from '../../../hooks/useExpand'
import { getGroupProducts } from '../utils'
import {
    rectSortingStrategy,
    SortableContext,
    useSortable,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface ProductsGroupContainerProps {
    productsList: IProduct[]
    groupData: IProductGroup
    hideInactive: boolean
    index?: any
}

export const ProductsGroupContainer = (props: ProductsGroupContainerProps) => {
    const dispatch = useAppDispatch()
    const authUser = new User()
    const { productsList, groupData, hideInactive } = props

    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({
            id: groupData.group_id,
        })

    const styles = {
        transform: CSS.Transform.toString(transform),
        transition,
    }

    const products = getGroupProducts(productsList, groupData)

    const { group_id: groupId } = groupData
    const expandBtnClassName = 'ms-3 btn-clean border-none'
    const { expandBtn, expanded, toggle } = useExpand({
        isExpanded: true,
        uniqueID: groupId,
        ariaID: groupId,
        className: expandBtnClassName,
    })

    const deleteGroupHandle = (): void => {
        dispatch(
            showModal(ModalTypes.DELETE_PRODUCTS_GROUP_MODAL, {
                groupId,
                products: products.map((product: IProduct) => product.guid),
            })
        )
    }

    return (
        <div
            ref={setNodeRef}
            style={styles}
            {...attributes}
            {...listeners}
        >
            <Card className={style.groupCard}>
                <div
                    className={expanded ? style.header : style.headerCollapsed}
                >
                    <div
                        className="w-100 d-flex align-items-center"
                        onClick={toggle}
                        aria-controls="collapse-card"
                        aria-expanded={expanded}
                    >
                        <h4 className={style.title}>{groupData?.name}</h4>
                        {expandBtn}
                    </div>
                    {authUser.isAdministratorOrOwner() && (
                        <AppButton
                            className="app-color-group"
                            onClick={deleteGroupHandle}
                            variant={'delete'}
                        />
                    )}
                </div>

                <div className={style.flexContainer}>
                    <Collapse in={expanded}>
                        <div
                            id="collapse-card"
                            style={{ width: '100%' }}
                        >
                            {!products.length ? (
                                <NoData
                                    style={{ height: '300px' }}
                                    messageId={
                                        hideInactive
                                            ? 'summary.noActiveProductsInGroup'
                                            : 'summary.noProductsInGroup'
                                    }
                                />
                            ) : (
                                <SortableContext
                                    items={groupData.entries.map(
                                        (pID) => `${groupId}:${pID}`
                                    )}
                                    strategy={rectSortingStrategy}
                                >
                                    <div
                                        className={style.body}
                                        // style={{
                                        //     display: 'grid',
                                        //     gridTemplateColumns:
                                        //         'repeat(auto-fill, minmax(22rem, 1fr))',
                                        //     gap: '5px',
                                        // }}
                                    >
                                        {products.map(
                                            (
                                                product: IProduct,
                                                index: number
                                            ) => (
                                                <ProductCard
                                                    product={product}
                                                    groupId={groupId}
                                                    key={`${groupId}:${product.guid}`}
                                                    index={index}
                                                />
                                            )
                                        )}
                                    </div>
                                </SortableContext>
                            )}
                        </div>
                    </Collapse>
                </div>
            </Card>
        </div>
    )
}
